<template>
  <div>
    <div style="background:linear-gradient(90deg,#4f5bd5,#5f2c82);color:#fff;padding:24px 16px 12px 16px;border-radius:8px;margin-bottom:20px;font-size:18px;">
      欢迎来到墅梯智选品牌管理后台！<br>
      您可以在此管理品牌数据，设置品牌名称和图标等信息。
    </div>
    <el-button type="primary" @click="openForm()" style="margin-bottom:16px">新增品牌</el-button>
    <div v-if="loading" style="text-align:center;padding:40px 0;color:#888;">
      正在加载数据，请稍候...
    </div>
    <div v-else-if="error" style="text-align:center;padding:40px 0;color:#e74c3c;">
      数据加载失败，请检查网络或稍后重试。
      <el-button type="text" @click="getList">重试</el-button>
    </div>
    <el-table v-else-if="list.length > 0" :data="list" style="width: 100%">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="name" label="品牌名称" />
      <el-table-column prop="icon" label="图标" width="100">
        <template #default="scope">
          <img v-if="scope.row.icon" :src="scope.row.icon" style="width: 40px; height: 40px; object-fit: contain;" />
          <span v-else style="color: #999;">无图标</span>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述" />
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button size="mini" @click="openForm(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteItem(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-else style="text-align:center;padding:40px 0;color:#888;">
      暂无品牌数据，请点击"新增品牌"按钮添加。
    </div>
    <brand-form :visible.sync="formVisible" :data="formData" @refresh="getList" />
  </div>
</template>

<script>
import axios from 'axios';
import BrandForm from './BrandForm.vue';

export default {
  name: 'BrandList',
  components: { BrandForm },
  data() {
    return {
      list: [],
      loading: false,
      error: false,
      formVisible: false,
      formData: null
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      this.error = false;
      try {
        const headers = { Authorization: localStorage.getItem('token') };
        const res = await axios.get('/api/admin/brand', { headers });
        if (res.data.code === 0) {
          this.list = res.data.data;
        } else {
          this.error = true;
        }
      } catch (error) {
        console.error('获取品牌列表失败:', error);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    openForm(data = null) {
      this.formData = data;
      this.formVisible = true;
    },
    async deleteItem(item) {
      try {
        await this.$confirm(`确定要删除品牌"${item.name}"吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        const headers = { Authorization: localStorage.getItem('token') };
        await axios.delete(`/api/admin/brand/${item.id}`, { headers });
        this.$message.success('删除成功');
        this.getList();
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败：' + (error.response && error.response.data && error.response.data.message || '未知错误'));
        }
      }
    }
  }
};
</script>

<style scoped>
/* 样式可以根据需要添加 */
</style>